import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleUtils = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    tabContainerSize: 0,
    groupTabs: {},
    swatchesByComponent: {},
    tabsSwatches: {},
    availableTabs: [],
    subgroups: {},
    palettes: [],
    palettesByComponent: {},
    selectedTabs: {},
    selectedSwatches: {},
    productOptionToggle: {},
    historySelectedTabs: [],
    swatchesRelation: {},
    exclusiveSwatches: {},
    paletteStripParams: [
      "recipe",
      "palette"
    ],
    disabledSwatchesByFeature: {
      personalization: [],
      ugc: [],
      patternMaker: [],
      imageLibrary: []
    },
    palettesId: [],
    exclusiveComponents: {},
    swatchesListByComponent: {},
    swatchesInPalettes: [],
    paletteTheme: null,
    paletteHiddenFeatures: {},
    splashTabs: []
  }
};

export default moduleUtils;
